import { RequirementDefinitionStandardBackgroundCheckFormValues } from "../../../../types";

export const getBackgroundCheckSettings = (
  settings: Partial<RequirementDefinitionStandardBackgroundCheckFormValues>
): string[] => {
  const items: string[] = [
    `Package: ${settings.package || "Standard package"}`
  ];

  if (settings.instructions) {
    items.push(`Instructions: ${settings.instructions}`);
  }

  return items;
};
